import { apiPrivacyUrl } from "../app/variables";

export default function (context, inject) {
  const { $config, error: nuxtError } = context;

  if (!context.$currentDomain) {
      console.error('ApiService Plugin Error: $currentDomain not injected. Make sure your domain plugin runs before this one.');
  }

  const baseURL = apiPrivacyUrl; // Базовый URL для API

  /**
   * Простая обертка над fetch
   * @param {string} path - Путь к ресурсу (например, '/api/website/privacy')
   * @param {object} options - Опции для fetch (method, headers, body, etc.)
   * @returns {Promise<any>} - Данные ответа или проброшенная ошибка
   */
  const simpleFetch = async (path, options = {}) => {
    const defaultHeaders = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };

    const requestOptions = {
      ...options,
      headers: {
        ...defaultHeaders,
        ...options.headers,
      },
    };

    // Если тело запроса - объект и Content-Type - JSON, сериализуем его
    if (requestOptions.body && typeof requestOptions.body === 'object' && requestOptions.headers['Content-Type'] === 'application/json') {
      requestOptions.body = JSON.stringify(requestOptions.body);
    }

    try {
      // Собираем полный URL
      const fullUrl = `${baseURL}${path}`;
      const response = await fetch(fullUrl, requestOptions);

      if (!response.ok) {
        let errorData;
        try {
          // Пытаемся прочитать тело ответа как JSON для получения деталей ошибки
          errorData = await response.json();
        } catch (e) {
          // Если не удалось прочитать как JSON, используем статус и текст
          errorData = { message: response.statusText || `HTTP error ${response.status}` };
        }
        // Создаем новую ошибку с полезной информацией
        const error = new Error(errorData.message || `HTTP error! Status: ${response.status}`);
        error.response = response; // Оригинальный объект ответа
        error.status = response.status; // HTTP статус
        error.data = errorData; // Детали ошибки из тела ответа
        console.error('[API Service] Fetch Error Details:', error.message, error.data);
        throw error; // Пробрасываем ошибку дальше
      }

      // Обрабатываем ответы без тела (например, 204 No Content)
      if (response.status === 204 || response.headers.get('content-length') === '0') {
        console.log(`[API Service] Received 204 No Content or empty body for ${fullUrl}`);
        return null;
      }

      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        console.log(`[API Service] Parsing JSON response for ${fullUrl}`);
        return response.json();
      }
      console.log(`[API Service] Parsing text response for ${fullUrl}`);
      return response.text();
    } catch (error) {
      console.error('[API Service] General Fetch Error:', error.message);
      throw error;
    }
  };

  // API методы
  const api = {
    /**
     * Получает политику конфиденциальности.
     * @param {object} policyParams - Параметры для запроса политики
     * @param {string} policyParams.legal_name - Юр. лицо
     * @param {string} policyParams.legal_ogrn - ОГРН
     * @param {string} policyParams.legal_inn - ИНН
     * @param {string} policyParams.legal_kpp - КПП
     * @param {string} policyParams.legal_address - Юр. адрес.
     * @returns {Promise<{heading: string, text: string}>} - Объект с заголовком и текстом политики.
     */
    getPrivacyPolicy: (policyParams) => {
      return simpleFetch('/api/website/privacy', {
        method: 'POST',
        body: {
          host: context.$currentDomain,
          ...policyParams
        },
      });
    },
  };

  inject('apiService', api);
}
